export default __webpack_public_path__ + "static/media/consent-2019.9ab1eaf3.jpg";